import React, { Component } from "react";
import { NormalButton } from "component/common";
export default class RequestMessage extends Component {
  render() {
    let { formFields, hideRequestBtn, customerRequestResponse } = this.props;
    return (
      <div>
        {formFields.custName && (
          <div className="row outletNameContainer">
            <div className="col-4 col-sm-3 col-md-3 col-lg-2 col-xl-2">
              <div>
                <h6 className="outletNameTitle">{formFields.custName}</h6>
                <h6 className="outletNameTitle">{formFields.cust_phone2}</h6>
                <h6>{formFields.site_code}</h6>
              </div>
            </div>
            {formFields.custId && hideRequestBtn && (
              <>
                {" "}
                <div className="col-8 col-sm-5 col-md-5 col-lg-4 col-xl-4">
                  <div className="transferCheckBoxContainer">
                    <input
                      type="checkbox"
                      checked={this.props.transferCheckbox}
                      name="transferCheckbox"
                      onChange={() => this.props.handleChangeBox()}
                    />

                    <h6 className="transferTitle">Permanent Transfer</h6>
                  </div>
                </div>
                <div className="col-12 col-sm-4 col-md-4 col-lg-3 col-xl-3">
                  <NormalButton
                    mainbg={true}
                    className="col-12 fs-14 float-right"
                    label="Request Customer"
                    onClick={() => this.props.handleClickRequest()}
                  />
                </div>
              </>
            )}
          </div>
        )}

        <div className="row outletRequestContainer">
          <div className="col-md-12 outletRequestContent">
            <div>
              <h6>{customerRequestResponse.message}</h6>
              <p>{customerRequestResponse.dateTime}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
